import { IAction } from "../../../interface/action.interface";
import { IListDto } from "../../../interface/dto/list.dto";

export enum ListSearchActionType {
    LIST_SEARCH_GET = "LIST_SEARCH_GET",
    LIST_SEARCH_GET_SUCCESS = "LIST_SEARCH_GET_SUCCESS",
    LIST_SEARCH_GET_ERROR = "LIST_SEARCH_GET_ERROR",
}

export interface IListSearchGetAction extends IAction {
    type: ListSearchActionType.LIST_SEARCH_GET;
    payload: {
        filter: string;
    };
}

export interface IListSearchGetSuccessAction extends IAction {
    type: ListSearchActionType.LIST_SEARCH_GET_SUCCESS;
    payload: {
        lists: Array<IListDto>;
    };
}

export interface IListSearchGetErrorAction extends IAction {
    type: ListSearchActionType.LIST_SEARCH_GET_ERROR;
    payload: {
        error: string;
    };
}

export const listSearchAction = (filter: string): IListSearchGetAction => ({
    type: ListSearchActionType.LIST_SEARCH_GET,
    payload: { filter },
});

export const listSearchSuccessAction = (
    lists: Array<IListDto>,
): IListSearchGetSuccessAction => ({
    type: ListSearchActionType.LIST_SEARCH_GET_SUCCESS,
    payload: { lists },
});

export const listSearchErrorAction = (error: string) => ({
    type: ListSearchActionType.LIST_SEARCH_GET_ERROR,
    payload: { error },
});

export type IListSearchAction =
    | IListSearchGetAction
    | IListSearchGetSuccessAction
    | IListSearchGetErrorAction;
